export const REGION = [{
    id: 0,
    full_name: '',
    code: ''
}]

export const OTP_DEFAULT = {
    box1: "",
    box2: "",
    box3: "",
    box4: "",
    box5: "",
    box6: ""
}

export const BUSINESS_PLAN = [
    {
        PlanPrice: [],
        id: 0,
        external_plan_ref: '',
        plan_name: '',
        plan_description: ''
    }
]